export const CALC_ACTION = 'CALC_ACTION'
export const LOAD_ACTION = 'LOAD_ACTION'
export const EXPANSION_ZOOM = 'EXPANSION_ZOOM'
export const PURGE_CACHE = 'PURGE_CACHE'
export const GET_CLUSTER_POINTS = 'GET_CLUSTER_POINTS'
export const MAP_MO = 8
export const MAP_GRID = 17

export function getFeatureId(feature) {
  if (feature.properties.cluster_id) {
    return `${
      feature.properties.subGroupId
    }_cluster_${feature.geometry.coordinates.join(',')}`
  }
  return `${feature.properties.subGroupId}_marker_${
    feature.properties.id
  }_${feature.geometry.coordinates.join(',')}`
}
